import { brandedPosters } from "../../mock/mock";

const BrandedShowcase = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-orange-50">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-orange-100 border border-orange-200 mb-4">
            <span className="text-xs font-semibold text-orange-700 tracking-widest uppercase">A Day in our School</span>
          </div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-stone-800 mb-4">
            Life at <span className="text-orange-600">Aadi Gayanam</span>
          </h2>
          <p className="text-stone-600">
            From morning prayers and Sanskrit shlokas to play, music, story time and outdoor exploration — every moment is designed to nurture the head, heart, hands and habits of your child.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {brandedPosters.map((p, i) => (
            <div
              key={p.id}
              className="group relative rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-1"
            >
              <img
                src={p.url}
                alt={p.title}
                className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-orange-950/95 via-orange-900/70 to-transparent p-6 pt-16">
                <h3 className="font-display font-bold text-xl md:text-2xl text-white mb-1">
                  {p.title}
                </h3>
                <p className="text-sm text-orange-100 leading-relaxed">
                  {p.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandedShowcase;
